/**
 |-----------------------------------------------------------------------------
 | main.js
 | v1.0.0
 |-----------------------------------------------------------------------------
 |
 | Some description...
 |
 | Contents
 |
 |  1. Vendor                                                              LN:1
 |  2. Custom                                                              LN:1
 |
 */

/*
 |
 | Vendor
 |
 */

window.$ = window.jQuery = require('jquery');

require('cookieconsent');
require('./vendor/headroom.js');
require('./vendor/infinite-scroll.js');
require('lazysizes');
require('./vendor/slick.js');





/*
 |
 | Custom
 |
 */

require('./custom/accordions.js');
require('./custom/forms.js');
require('./custom/menu.js');
require('./custom/modals.js');
require('./custom/select.js');
require('./custom/snippets.js');
